import axios from 'axios'; // ??kb
import 'lazysizes'; // 100kb
// JS Cookie
const Cookies = require('./libraries/js.cookie'); // ??kb
require('./translation');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default; // 200kb
    window.$ = window.jQuery = require('jquery'); // in vendor

    require('bootstrap'); // 400kb
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.defaults.withCredentials = true;

// Global cancel token
const CancelToken = window.axios.CancelToken;
window.axiosSource = CancelToken.source();

// Cancel axios calls with cancel token on from submit
const forms = document.getElementsByTagName('form');
for (var i = 0; i < forms.length; i++) {             
    forms[i].addEventListener("submit", function(e) {
        window.axiosSource.cancel('Operation canceled by the user.');
    });
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
